import { IconProps } from '@velocity-exchange/icons';
import { cj } from 'src/utils/classNames';
import { getColorVar } from 'src/utils/theme/colorVars';

export default function MegaphoneWithDot({
	size = 16,
	className,
	color,
	...props
}: IconProps) {
	return (
		<span className={cj('inline-flex', className)} {...props}>
			<svg
				xmlns="http://www.w3.org/2000/svg"
				width={size}
				height={size}
				fill="none"
				viewBox="0 0 24 24"
			>
				<path
					fill={color ?? 'currentColor'}
					d="M12.129 7.686c.11.499.286.973.521 1.41l-8.9 2.473v1.829l16.5 3.666v-5.802a5.5 5.5 0 0 0 1.5-1.272V18a.75.75 0 0 1-.913.732l-8.49-1.886a.8.8 0 0 1-.024.153 3.76 3.76 0 0 1-7.299-1.781l-2.187-.486A.75.75 0 0 1 2.25 14v-3l.01-.124a.75.75 0 0 1 .539-.599zM6.49 15.544a2.259 2.259 0 0 0 4.387 1.057 1 1 0 0 1 .025-.077z"
				/>
				<path
					fill={getColorVar('negative-red')}
					d="M17.5 11a4.5 4.5 0 1 0 0-9 4.5 4.5 0 0 0 0 9"
				/>
			</svg>
		</span>
	);
}
